import LoginFormView from './login-form.vue'
import LoginCodeView from './login-code.vue'

export const LoginFormRoute = {
    // Process link with an app-code
    name: 'login',
    path: '/login',
    component: LoginFormView,     
    props: false, 
}

export const LoginCodeRoute = {
   // Process link with an app-code
   name: 'logincode',
   path: '/loginbyemail/:code?',
   component: LoginCodeView,     
   props: true, 
}

export default { LoginFormRoute, LoginCodeRoute }
